import { runNativeFunction } from 'utils/native';
import { isAndroid } from 'utils/platform';

export function onCopy(text: string): void | Promise<void> {
  return isAndroid()
    ? runNativeFunction('copyToClipboard', text)
    : window.navigator.clipboard.writeText(text);
}
